import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'paytm',
  templateUrl: './paytm.component.html',
  styleUrls: ['./paytm.component.css']
})
export class PaytmComponent {
  @ViewChild("form") form: ElementRef;
  payWithPayTM()
  {
    alert("Data")
    this.form.nativeElement.submit();
  }
}
